'use client';

import Script from 'next/script';
import { Locale, getLocale } from '@libs/core';

const isLocaleUs = getLocale() === Locale['en-US'];
const oneTrustScriptSrc = isLocaleUs
    ? process.env.NEXT_PUBLIC_ONETRUST_SCRIPT_US_URL
    : process.env.NEXT_PUBLIC_ONETRUST_SCRIPT_CA_URL;

export function OneTrustScript({
    scriptId,
}: Readonly<{ scriptId: string | undefined }>) {
    return (
        <Script
            id="OneTrust-Script"
            strategy="afterInteractive"
            /*
              If we set the strategy parameter [strategy=“beforeInteractive”], we will get this error
              >>> Error:
              Uncaught SyntaxError: Unexpected token '<', "<!DOCTYPE "... is not valid JSON...
             */
            src={oneTrustScriptSrc ?? ''}
            data-domain-script={scriptId}
            data-testid="onetrust-script-test"
        />
    );
}
